/* bb-cart-selection.js — Bara Bros Select-A
   Phase: UI + state only. No checkout interception, no cart modification. */
(function () {
  'use strict';

  var LS_KEY = 'bb_cart_selections';
  var VERSION = 1;
  var observerTimer = null;
  var mutationObserver = null;

  // ── localStorage ────────────────────────────────────────────────────────
  function loadState() {
    try {
      var raw = localStorage.getItem(LS_KEY);
      if (!raw) return { version: VERSION, updatedAt: Date.now(), items: {} };
      var d = JSON.parse(raw);
      if (!d || typeof d.items !== 'object') return { version: VERSION, updatedAt: Date.now(), items: {} };
      return d;
    } catch (_) {
      return { version: VERSION, updatedAt: Date.now(), items: {} };
    }
  }

  function saveState(state) {
    try {
      state.updatedAt = Date.now();
      localStorage.setItem(LS_KEY, JSON.stringify(state));
    } catch (_) {}
  }

  // ── Money formatting ─────────────────────────────────────────────────────
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var fmt = window.Shopify.money_format || '${{amount}}';
      return window.Shopify.formatMoney(cents, fmt);
    }
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ── DOM helpers ──────────────────────────────────────────────────────────
  function getRows() {
    return Array.from(document.querySelectorAll('[data-bb-line-key]'));
  }

  function getItemCheckbox(row) {
    return row.querySelector('.bb-sel-input:not(.bb-sel-all-input)');
  }

  // ── Prune stale keys that no longer exist in the DOM ────────────────────
  function pruneStale(state) {
    var liveKeys = {};
    getRows().forEach(function (r) { liveKeys[r.dataset.bbLineKey] = true; });
    var pruned = {};
    Object.keys(state.items).forEach(function (k) {
      if (liveKeys[k]) pruned[k] = state.items[k];
    });
    state.items = pruned;
  }

  // ── Update all counter and subtotal UI ──────────────────────────────────
  function updateUI() {
    var selectedCount = 0;
    var totalCount = 0;
    var selectedCents = 0;

    getRows().forEach(function (row) {
      var cb = getItemCheckbox(row);
      if (!cb) return;
      totalCount++;
      var price = parseInt(row.dataset.bbLinePrice || '0', 10);
      if (cb.checked) {
        selectedCount++;
        selectedCents += price;
      }
    });

    document.querySelectorAll('.bb-sel-selected-count').forEach(function (el) {
      el.textContent = selectedCount;
    });
    document.querySelectorAll('.bb-sel-all-count').forEach(function (el) {
      el.textContent = totalCount;
    });
    document.querySelectorAll('.bb-sel-total-count').forEach(function (el) {
      el.textContent = totalCount;
    });
    document.querySelectorAll('.bb-sel-subtotal-value').forEach(function (el) {
      el.textContent = formatMoney(selectedCents);
    });

    document.querySelectorAll('.bb-sel-all-input').forEach(function (allCb) {
      if (totalCount === 0) {
        allCb.checked = false;
        allCb.indeterminate = false;
      } else if (selectedCount === totalCount) {
        allCb.checked = true;
        allCb.indeterminate = false;
      } else if (selectedCount === 0) {
        allCb.checked = false;
        allCb.indeterminate = false;
      } else {
        allCb.checked = false;
        allCb.indeterminate = true;
      }
    });

    // Disable strip checkout buttons (mobile / hidden on desktop)
    document.querySelectorAll('.bb-sel-checkout-btn').forEach(function (btn) {
      var disabled = selectedCount === 0;
      btn.disabled = disabled;
      btn.classList.toggle('bb-sel-checkout-btn--disabled', disabled);
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    });

    // ── Main checkout button + Select-B info area ─────────────────────────────
    var hasSelUI     = !!document.querySelector('.bb-sel-input');
    var hasSelChk    = !!document.querySelector('.bb-sel-checkout-btn[data-checkout-selected]');
    var mainBtn      = document.querySelector('[data-bb-main-checkout]');
    var showSelectB  = hasSelUI && hasSelChk;

    var infoArea      = document.querySelector('.bb-sel-info');
    var noteEl        = document.querySelector('.bb-sel-note');
    var chkAllWrap    = document.querySelector('.bb-sel-checkout-all-wrap');

    if (infoArea)   infoArea.style.display   = hasSelUI    ? 'block' : 'none';
    if (noteEl)     noteEl.style.display     = showSelectB ? 'block' : 'none';
    if (chkAllWrap) chkAllWrap.style.display = showSelectB ? 'block' : 'none';

    if (mainBtn && showSelectB) {
      var btnInner = mainBtn.querySelector('.button-text-main') || mainBtn;
      mainBtn.disabled = (selectedCount === 0);
      btnInner.textContent = 'Checkout (' + selectedCount + ')';
    }

    // ── Express payment safety: hide accelerated buttons on partial/zero selection ──
    var isSelectPartial = showSelectB && selectedCount > 0 && selectedCount < totalCount;
    var isSelectNone    = showSelectB && selectedCount === 0;
    var isSelectAll     = showSelectB && selectedCount === totalCount && totalCount > 0;
    document.body.classList.toggle('bb-select-partial-active', isSelectPartial);
    document.body.classList.toggle('bb-select-none-active',    isSelectNone);
    document.body.classList.toggle('bb-select-all-active',     isSelectAll);

    if (window.BB_CART_SELECT_DEBUG) {
      var _btnTextEl = mainBtn ? (mainBtn.querySelector('.button-text-main') || mainBtn) : null;
      console.log('[BB-SelectB] main checkout bind', {
        buttonFound: !!mainBtn,
        selectedCount: selectedCount,
        totalCount: totalCount,
        selectBEnabled: showSelectB,
        hasSelUI: hasSelUI,
        hasSelChk: hasSelChk,
        stripBtnInDOM: document.querySelectorAll('.bb-sel-checkout-btn[data-checkout-selected]').length,
        infoAreaInDOM: !!infoArea,
        buttonText: _btnTextEl ? _btnTextEl.textContent.trim() : null
      });
    }
  }

  // ── Apply stored state to current DOM ───────────────────────────────────
  function initRows() {
    var rows = getRows();
    if (!rows.length) return;

    var state = loadState();
    pruneStale(state);

    rows.forEach(function (row) {
      var key = row.dataset.bbLineKey;
      var cb = getItemCheckbox(row);
      if (!cb) return;

      // Default new items to selected
      if (!(key in state.items)) {
        state.items[key] = true;
      }

      var isChecked = state.items[key] !== false;
      cb.checked = isChecked;
      row.classList.toggle('bb-sel-row--unchecked', !isChecked);
    });

    saveState(state);
    updateUI();
  }

  // ── Event delegation (survives DOM replacement) ──────────────────────────
  document.addEventListener('change', function (e) {
    // Item checkbox
    if (e.target.classList.contains('bb-sel-input') && !e.target.classList.contains('bb-sel-all-input')) {
      var row = e.target.closest('[data-bb-line-key]');
      if (!row) return;
      var key = row.dataset.bbLineKey;
      var state = loadState();
      state.items[key] = e.target.checked;
      saveState(state);
      row.classList.toggle('bb-sel-row--unchecked', !e.target.checked);
      updateUI();
    }

    // Select All checkbox
    if (e.target.classList.contains('bb-sel-all-input')) {
      var checked = e.target.checked;
      var state = loadState();
      getRows().forEach(function (row) {
        var k = row.dataset.bbLineKey;
        state.items[k] = checked;
        var cb = getItemCheckbox(row);
        if (cb) {
          cb.checked = checked;
          row.classList.toggle('bb-sel-row--unchecked', !checked);
        }
      });
      saveState(state);
      updateUI();
    }
  });

  // ── MutationObserver — re-init after AJAX cart updates ──────────────────
  function setupObserver() {
    if (mutationObserver) mutationObserver.disconnect();

    var targets = [
      document.getElementById('main-cart'),        // stable cart-items-component (survives replaceWith on children)
      document.getElementById('main-cart-items'),  // items tbody (may detach after AJAX, kept as fallback)
      document.querySelector('cart-drawer-items')
    ].filter(Boolean);

    if (!targets.length) return;

    mutationObserver = new MutationObserver(function () {
      clearTimeout(observerTimer);
      observerTimer = setTimeout(initRows, 150);
    });

    targets.forEach(function (t) {
      mutationObserver.observe(t, { childList: true, subtree: true });
    });
  }

  // ── Select-B: constants and flags ────────────────────────────────────────
  var BB_BACKUP_KEY = 'bb_selective_checkout_backup';
  var BB_BACKUP_TTL = 86400000; // 24 h
  var pending = false;
  var restoring = false;

  // ── Select-B: debug logger ────────────────────────────────────────────────
  function dbg() {
    if (window.BB_CART_SELECT_DEBUG) {
      console.log.apply(console, ['[BB-SelectB]'].concat(Array.prototype.slice.call(arguments)));
    }
  }

  // ── Select-B: cart API helpers ────────────────────────────────────────────
  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function removeByKeys(itemKeys) {
    var updates = {};
    itemKeys.forEach(function (k) { updates[k] = 0; });
    dbg('removeByKeys payload:', JSON.stringify(updates));
    return fetch('/cart/update.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); });
  }

  function addItems(items) {
    return fetch('/cart/add.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('batch');
    }).catch(function () {
      // Batch failed — restore one at a time, skipping sold-out items
      var chain = Promise.resolve();
      items.forEach(function (item) {
        chain = chain.then(function () {
          return fetch('/cart/add.json', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [item] })
          }).catch(function () {});
        });
      });
      return chain;
    });
  }

  // ── Select-B: backup helpers ──────────────────────────────────────────────
  // uncheckedKeySet: plain object whose keys are the item.key strings to remove
  function buildBackup(cartJson, uncheckedKeySet) {
    var backup = { cartToken: cartJson.token, savedAt: Date.now(), items: [] };
    cartJson.items.forEach(function (cartItem) {
      if (!uncheckedKeySet[cartItem.key]) return;
      var entry = {
        id: cartItem.variant_id,
        quantity: cartItem.quantity,
        properties: cartItem.properties || {}
      };
      if (cartItem.selling_plan_allocation && cartItem.selling_plan_allocation.selling_plan) {
        entry.selling_plan = cartItem.selling_plan_allocation.selling_plan.id;
      }
      backup.items.push(entry);
    });
    dbg('buildBackup result:', JSON.stringify(backup));
    return backup;
  }

  function loadBackup() {
    try {
      var raw = localStorage.getItem(BB_BACKUP_KEY);
      if (!raw) return null;
      var b = JSON.parse(raw);
      if (!b || !b.cartToken || !Array.isArray(b.items) || !b.savedAt) return null;
      if (Date.now() - b.savedAt > BB_BACKUP_TTL) { localStorage.removeItem(BB_BACKUP_KEY); return null; }
      return b;
    } catch (_) { return null; }
  }

  // ── Select-B: restore on return from checkout ─────────────────────────────
  function checkAndRestore() {
    var backup = loadBackup();
    if (!backup || restoring) return;
    restoring = true;
    fetchCart().then(function (cartJson) {
      if (cartJson.token !== backup.cartToken) {
        // Checkout was completed — new cart token, discard backup
        localStorage.removeItem(BB_BACKUP_KEY);
        restoring = false;
        return;
      }
      return addItems(backup.items).then(function () {
        localStorage.removeItem(BB_BACKUP_KEY);
        location.reload();
      });
    }).catch(function () { restoring = false; });
  }

  // ── Select-B: core checkout logic (shared by strip button + main button) ──
  function runSelectBCheckout(btn) {
    pending = true;
    btn.disabled = true;
    var btnInner = btn.querySelector('.button-text-main') || btn;
    btnInner.textContent = 'Processing…';

    dbg('Checkout Selected clicked');

    fetchCart().then(function (cartJson) {
      dbg('cart.js items:', cartJson.items.map(function (i) { return i.key + ' qty=' + i.quantity; }));

      var selState = loadState();
      dbg('localStorage selections:', JSON.stringify(selState.items));

      var uncheckedKeySet = {};
      var uncheckedKeys = [];
      cartJson.items.forEach(function (cartItem) {
        var isSelected = selState.items[cartItem.key] !== false;
        dbg('item', cartItem.key, isSelected ? 'SELECTED' : 'UNCHECKED');
        if (!isSelected) {
          uncheckedKeySet[cartItem.key] = true;
          uncheckedKeys.push(cartItem.key);
        }
      });

      if (uncheckedKeys.length === 0) {
        dbg('All items selected, navigating directly to /checkout');
        window.location.href = '/checkout';
        return;
      }

      dbg('Keys to remove:', uncheckedKeys);

      var backup = buildBackup(cartJson, uncheckedKeySet);
      localStorage.setItem(BB_BACKUP_KEY, JSON.stringify(backup));

      return removeByKeys(uncheckedKeys).then(function () {
        return fetchCart().then(function (verifyCart) {
          var remaining = verifyCart.items.filter(function (i) { return uncheckedKeySet[i.key]; });
          dbg('Safety verify — remaining unchecked keys in cart:', remaining.map(function (i) { return i.key; }));

          if (remaining.length > 0) {
            dbg('Safety FAIL — some items were not removed');
            localStorage.removeItem(BB_BACKUP_KEY);
            throw new Error('safety');
          }

          dbg('Safety OK — navigating to /checkout');
          window.location.href = '/checkout';
        });
      });
    }).catch(function (err) {
      pending = false;
      btn.disabled = false;
      updateUI();
      // Strip button restores its own text; main button text is reset by updateUI()
      if (!btn.hasAttribute('data-bb-main-checkout')) {
        btn.textContent = 'Checkout Selected';
      }
      if (err && err.message === 'safety') {
        alert('Could not prepare selected checkout. Please try again or use normal checkout.');
      }
      dbg('Error in checkout flow:', err);
    });
  }

  // ── Capture-phase guard: stop checkbox taps reaching cart-item__link ────────
  document.addEventListener('click', function (e) {
    if (e.target.closest('.bb-sel-check')) {
      e.stopPropagation();
    }
  }, true);

  // ── Media cell tap → toggle checkbox (image link has pointer-events:none in select mode) ──
  document.addEventListener('click', function (e) {
    var media = e.target.closest('.bb-sel-active .cart-item__media');
    if (!media) return;
    if (e.target.closest('.bb-sel-check')) return; // label handles its own click
    var chk = media.querySelector('.bb-sel-input');
    if (!chk) return;
    chk.checked = !chk.checked;
    chk.dispatchEvent(new Event('change', { bubbles: true }));
  }, false);

  // ── Select-B: strip button (mobile / hidden on desktop via CSS) ───────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bb-sel-checkout-btn[data-checkout-selected]');
    if (!btn || btn.disabled || pending) return;
    e.preventDefault();
    e.stopPropagation();
    runSelectBCheckout(btn);
  });

  // ── Select-B: main order-summary checkout button (desktop repurposed) ─────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bb-main-checkout]');
    if (!btn) return;
    // Only intercept when Select-B checkout is active; otherwise let form submit normally
    var selectBEnabled = !!document.querySelector('.bb-sel-checkout-btn[data-checkout-selected]');
    if (window.BB_CART_SELECT_DEBUG) {
      var _rows = getRows();
      var _sel  = _rows.filter(function (r) { var c = getItemCheckbox(r); return c && c.checked; }).length;
      console.log('[BB-SelectB] main checkout clicked', {
        selectBEnabled: selectBEnabled,
        selectedCount: _sel,
        totalCount: _rows.length
      });
    }
    if (!selectBEnabled) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled || pending) return;
    runSelectBCheckout(btn);
  });

  // ── Bootstrap ────────────────────────────────────────────────────────────
  function init() {
    if (!document.querySelector('.bb-sel-input')) return;
    dbg('init()', {
      selInputs:     document.querySelectorAll('.bb-sel-input').length,
      mainBtn:       !!document.querySelector('[data-bb-main-checkout]'),
      selectBSignal: !!document.querySelector('.bb-sel-checkout-btn[data-checkout-selected]'),
      infoArea:      !!document.querySelector('.bb-sel-info')
    });
    initRows();
    setupObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      // Only restore on the main cart page — not on checkout or other pages
      if (document.getElementById('main-cart-items')) checkAndRestore();
      init();
    });
  } else {
    if (document.getElementById('main-cart-items')) checkAndRestore();
    init();
  }

  // Re-init on drawer open in case it lazy-renders
  document.addEventListener('cart-drawer:open', function () { setTimeout(init, 50); });
  document.addEventListener('cart:refresh', init);
  // cart.js dispatches 'cart:updated' after every AJAX section replacement.
  // Re-run init so the panel is shown and the observer is re-bound to the new DOM nodes.
  document.addEventListener('cart:updated', function () { setTimeout(init, 0); });

})();
